import * as PropTypes from 'prop-types';

export type Location = { latitude: number, longitude: number } | google.maps.LatLng | google.maps.LatLngLiteral;

export const locationPropTypeShape = {
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
};


export const locationPropType = PropTypes.shape(locationPropTypeShape);

// Location mapping between ours and google's
export function mapLocation(position: Location): google.maps.LatLngLiteral | google.maps.LatLng
export function mapLocation(position: Location[]): google.maps.LatLngLiteral[] | google.maps.LatLng[]

export function mapLocation(input: Location[] | Location): (google.maps.LatLngLiteral | google.maps.LatLng) | ((google.maps.LatLngLiteral | google.maps.LatLng)[]) {
    const map = (p: Location) => p && (isLocation(p) ? { lat: p.latitude, lng: p.longitude } : p);

    if (input instanceof Array) {
        return input.map(map);
    }
    return map(input);
}

function isLocation(input: google.maps.LatLngLiteral | google.maps.LatLng | Location): input is { latitude: number, longitude: number } {
    return (input as any).latitude !== undefined;
}